import Candidate from '@models/Candidate';
import React, {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
} from 'react';

export interface Photo {
  id: string;
  url: string;
  selected: boolean;
  picked: boolean;
}
interface CandidateContextData {
  video: any;
  photos: any[];
  videoDuration: number;
  recordChunksG: any;
  setRecordChunksG: any;
  isSplitPhotos: boolean;
  setIsSplitPhotos: Dispatch<SetStateAction<any | null>>;
  setVideoDuration: Dispatch<SetStateAction<any | null>>;
  setVideo: Dispatch<SetStateAction<any | null>>;
  setPhotos: Dispatch<SetStateAction<any[]>>;
  handleDeletePhoto: (id: string) => void;
  candidate: Candidate | null;
  setCandidate: Dispatch<SetStateAction<Candidate | null>>;
}
export const CandidateContext = createContext<
  CandidateContextData | undefined | any
>(undefined);

const CandidateProvider = ({ children }: { children: ReactNode }) => {
  const [video, setVideo] = React.useState<any>(null);

  const [photos, setPhotos] = React.useState<any[]>([]);
  const [recordChunksG, setRecordChunksG] = React.useState([]);
  const [videoDuration, setVideoDuration] = React.useState<any>(0);
  const [candidate, setCandidate] = React.useState<Candidate | null>(null);
  const [isSplitPhotos, setIsSplitPhotos] = React.useState(false);

  const handleDeletePhoto = (photoId: string) => {
    const newPhotos = photos.filter((photo) => photo.id !== photoId);
    setPhotos(newPhotos);
  };

  return (
    <CandidateContext.Provider
      value={{
        isSplitPhotos,
        setIsSplitPhotos,
        video,
        setVideo,
        photos,
        setPhotos,
        videoDuration,
        setVideoDuration,
        handleDeletePhoto,
        recordChunksG,
        setRecordChunksG,
        candidate,
        setCandidate,
      }}
    >
      {children}
    </CandidateContext.Provider>
  );
};

export default CandidateProvider;
